import React from 'react';
import Skeleton from 'react-loading-skeleton';

import AccountSkeleton from '../../../../components/AccountList/AccountSkeleton';

import './AccountListSkeleton.scss';

export const AccountListSkeleton: React.FC<{ count?: number; noTitle?: boolean }> = ({
    count = 3,
    noTitle = false,
}) => (
    <>
        {!noTitle && <Skeleton className="account-list__skeleton-header" width={150} height={30} />}
        <AccountSkeleton count={count} />
    </>
);
